import {text_field_change} from "../../redux/actions";
import React from "react";
import {useDispatch, useSelector} from "react-redux";

export const CargoName = () => {
    const dispatch = useDispatch()
    const value = useSelector(state => state.app.fields.cargoName.value)
    const error = useSelector(state => state.app.fields.cargoName.error)
    return (
        <React.Fragment>
            <label htmlFor="city_from">Наименование груза</label>
            <input type="text" id="cargo_name" className={'text-input' + (error ? ' error' : '')} name="cargo_name" placeholder="Введите текст"
                   value={value}
                   onChange={(e) => dispatch(text_field_change('cargo_name', e.target.value))}
            />
            {
                error && (<div className="text-input-error">Введите наименование груза</div>)
            }
        </React.Fragment>
    )
}